import { color } from "d3-color";
import defaults from "./defaults.js";
/**
    Assigns a color to a value using a predefined set of defaults.
    @param c A valid CSS color string.
    @param u An object containing overrides of the default colors.
*/ export default function(c) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // If the value is null or undefined, set to grey.
    if ([
        null,
        undefined
    ].indexOf(c) >= 0) return u["missing"] || defaults["missing"];
    else if (c === true) return u["on"] || defaults["on"];
    else if (c === false) return u["off"] || defaults["off"];
    else {
        var p = color(c);
        // If the value is not a valid color string, use the color scale.
        if (!p) return (u["scale"] || defaults["scale"])(c);
        return c;
    }
}

//# sourceMappingURL=assign.js.map